import React, {Fragment, useState, useEffect, useContext} from "react";
import queryString from "query-string";

import ResourcesTable from "root/Tables/ResourcesTable";
import '../../../Resources/Body/ResourcesTab.scss';

import useModalAddResource from "../../../../../Modals/AddResource/useModalAddResource";
import {getResources, updateResourceAccessForChild} from "root/DataFunctions/ResourceDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {useLocation} from "react-router-dom";
import {ResourceType, ResourceTypeFilters} from "root/DataFunctions/Constants";
// import bootbox from "bootbox";
import {useSetRecoilState} from "recoil";
import {childNameAtom} from "root/recoil/childName";
import {getChildDetails} from "root/DataFunctions/ChildDataFns";

const ChildResourcesTab = (props) =>
{
    const [data, setData] = useState({loading: true, data: []});

    const [renderAddResourceModal, showAddResourceModal] = useModalAddResource((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    const resourceFilterDefault = 'feelings';
    const { search } = useLocation();
    const queryParams = queryString.parse(search) ;
    const resourceFilter = queryParams.type === undefined?resourceFilterDefault:queryParams.type;

    useEffect(() => {
        getData();
    }, [resourceFilter, props.child_uid]);

    const getChildId = () =>
    {
        return props.child_uid;
    }

    const getData = () => {
        const approved = resourceFilter === 'allon' ?true : false;

        getResources( getChildId(), getResourceType(), approved, (response) =>
        {
            const data = getDataFromResponse( response ) ;
            setData({ isLoading: false, data: data});
        });
    }

    //Get child's data and set the global child name used by the various body header
    const setChildName = useSetRecoilState(childNameAtom);

    useEffect(() => {
        getChildData();
    }, [props.child_uid]);

    const getChildData = () =>{
        if(props.child_uid !== undefined)
        {
            getChildDetails(props.child_uid, (response) =>
            {
                let childData = getDataFromResponse(response)[0];
                // Set the recoil childNameAtom to the first child
                setChildName(childData.firstname + " " + childData.surname);
            });
        }
    }

    const getResourceType = () => {
        let resourceType = null;

        switch (resourceFilter){
            case ResourceTypeFilters.FEELINGS:
                resourceType = ResourceType.FEELINGS
                break
            case ResourceTypeFilters.GAME:
                resourceType = ResourceType.GAME
                break
            case ResourceTypeFilters.LEARNING:
                resourceType = ResourceType.LEARNING
                break
            case ResourceTypeFilters.HELP:
                resourceType = ResourceType.HELP
                break
            case 'allon':
                resourceType = ResourceType.ALL
                break
            case 'alloff':
                resourceType = ResourceType.ALL
                break
            default:
                resourceType = ResourceType.ALL
        }

        return resourceType;
    }

    const updateResourceChild = (resource_id, onOff) =>
    {
        let message = onOff === 'on'?'Are you sure you want to add this resource to this child?':'Are you sure you want to remove this resource from this child?'
        bootbox.confirm({
            size: "small",
            message: message,
            callback: (result =>
            {
                if (result)
                {
                    updateResourceAccessForChild(props.child_uid, resource_id, onOff,(response) =>
                    {
                        getData();
                    });
                }
            })
        })
    }


    const clickHandler = (mode, resource_id) =>
    {
        switch ( mode)
        {
            case 'remove' :
                updateResourceChild(resource_id, 'off');
                break;
            case 'add' :
                updateResourceChild(resource_id, 'on');
                break;
            case 'view' :
                showAddResourceModal(mode, resource_id, props.child_uid);
                break;
            case 'create' :
                showAddResourceModal(mode, resource_id, props.child_uid);
                break;
        }
    }

    return (
        <Fragment>
            <div className="family-body">
                <ResourcesTable child_uid={props.child_uid} loading={data.loading} data={data.data} clickHandler={clickHandler}/>
            </div>

            {renderAddResourceModal(props)}
        </Fragment>
    )
}

ChildResourcesTab.defaultProps = {};

export default ChildResourcesTab;

